import { EditableTitleProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: EditableTitleProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as EditableTitleProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      initialValue: 'Some Title',
    } as EditableTitleProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
